export function ebCtnRequestValidate () {
  const ebCtnRequestRule = [
    {
      property: 'ctnQuantity',
      ruleName: "length",
      min : 0,
		  max : 50,
      message: "不能为空且不能超过50字符"
    },
    {
      property: 'ctnSizeType',
      ruleName: "length",
      min : 0,
		  max : 50,
      message: "不能为空且不能超过50字符"
    },
    {
      property: 'ctnCompanyName',
      ruleName: "length",
      min : 0,
		  max : 50,
      message: "不能为空且不能超过50字符"
    },
    {
      property: 'noOfPackage',
      ruleName: "length",
      min : 0,
		  max : 50,
      message: "不能为空且不能超过50字符"
    },
    {
      property: 'grossWeight',
      ruleName: "length",
      min : 0,
		  max : 10,
      message: "不能为空且不能超过50字符"
    },
    {
      property: 'netWeight',
      ruleName: "length",
      min : 0,
		  max : 10,
      message: "不能为空且不能超过50字符"
    },
    {
      property: 'cube',
      ruleName: "length",
      min : 0,
		  max : 10,
      message: "不能为空且不能超过50字符"
    },
    {
      property: 'cargoDescription',
      ruleName: "length",
      min : 0,
		  max : 200,
      message: "不能为空且不能超过200字符"
    },
    {
      property: 'marks',
      ruleName: "length",
      min : 0,
		  max : 200,
      message: "不能为空且不能超过200字符"
    }
  ];
  return ebCtnRequestRule;
}

export function ebCargoDValidate () {
  const ebCargoDRules = [
    {
      property: 'cube',
      ruleName: "notNull",
      message: "体积不能为空"
    },
    {
      property: 'grossWeight',
      ruleName: "notNull",
      message: "毛重不能为空"
    },
    {
      property: 'noOfPackage',
      ruleName: "notNull",
      message: "件数不能为空"
    },
    {
      property: 'packageTypeName',
      ruleName: "notNull",
      message: "包装单位不能为空"
    },
  ];
  return ebCargoDRules;
}